import { Outlet } from 'react-router-dom';

import Header from 'pages/landing/components/Header';

const InfoLayout = () => (
    <>
        {/* <InfoHeader /> */}
        <Header />
        <Outlet />
    </>
);

export default InfoLayout;
